import Image from 'next/image';
import WelcomeImage from '@purpose/ui/assets/static/Welcome.svg';
import {cn} from '@purpose/ui/lib/utils';

const WithWelcomeImage = ({
  children,
  containerClassname
}: {
  children: React.ReactNode;
  containerClassname?: string;
}) => (
  <div
    className={cn(
      'relative flex h-screen w-screen flex-col items-center overflow-hidden',
      containerClassname
    )}
  >
    <div className="absolute right-[-144px] bottom-[-96px] -z-10 h-[324px] w-[305px] sm:right-[-108px] sm:bottom-[-168px] sm:h-[376px] sm:w-[354px] md:right-[-96px] md:bottom-[-147px] md:h-[420px] md:w-[396px] lg:right-[-376px] lg:bottom-[-180px] lg:h-[804px] lg:w-[758px] xl:right-[-381px] xl:bottom-[-180px] xl:h-[804px] xl:w-[758px]">
      <Image
        src={WelcomeImage}
        alt="Welcome"
        // to do: recheck once tailwind config is fixed
        style={{objectFit: 'contain', width: '100%', height: '100%'}}
        priority
      />
    </div>
    {children}
  </div>
);

export default WithWelcomeImage;
